import { useEffect, useState } from "react";
import { useEvents } from "@/hooks/events/useEvents";
import { EventList } from "@/components/events/EventList";
import { EventAssignmentsPanel } from "@/components/events/EventAssignmentsPanel";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";

const EventsPage = () => {
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { data: events = [], isLoading } = useEvents(search);

  useEffect(() => {
    if (!selectedId && events.length) setSelectedId(events[0].id);
  }, [events, selectedId]);

  const selected = events.find((e) => e.id === selectedId) ?? null;

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <SidebarInset>
          <div className="container max-w-7xl mx-auto px-4 py-6">
      <h1 className="text-2xl font-bold mb-4">Event Management</h1>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        <div className="lg:col-span-4 h-[calc(100vh-180px)]">
          <EventList
            events={events}
            selectedId={selectedId}
            onSelect={setSelectedId}
            search={search}
            onSearchChange={setSearch}
            isLoading={isLoading}
          />
        </div>
        <div className="lg:col-span-8">
          {selected ? (
            <EventAssignmentsPanel event={selected} />
          ) : (
            <div className="border rounded-lg p-12 text-center text-muted-foreground bg-card">
              เลือก event ทางซ้ายเพื่อดูรายชื่อนักเรียน
            </div>
          )}
        </div>
      </div>
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default EventsPage;
